import { FormGroup, FormControl, FormArray } from '@angular/forms';

export class ValidationService {
  static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
    let config = {
        'required': 'Required',
        'minlength': `Minimum length ${validatorValue.requiredLength}`,
        'maxlength': `Maxmum length ${validatorValue.requiredLength}`,
        'minFilteredLength': `Minimum length ${validatorValue}`,
        'invalidEmailAddress': 'Invalid email',
        'passwordsMismatch': 'Passwords are not equal',
        'dateRequired': 'Full date is required',
        'fullAddressRequired': 'Full address is required',
        'minArrayLength': `At least ${validatorValue} required`,
        'maxArrayLength': `You can not add more than ${validatorValue}`,
        'minValue': `Minimum is ${validatorValue}`
    };

    return config[validatorName];
  }

  static minFilteredLength(min: Number) {
    return (control: FormControl) => {
      if(control['value']) {
        let  filtered_value = control['value'].replace(/\D/g, '');
        if(isNaN(filtered_value) || filtered_value.length < min) {
          return { 'minFilteredLength': min };
        }
      }
    }
  }

  static emailValidator(control: Object) {
    if (control['value'].match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
        return null;
    } else {
        return { 'invalidEmailAddress': true };
    }
  }

  static matchingPasswords(group: FormGroup) {
    let password = group.controls['password'].value;
    let confirmPassword = group.controls['password_confirmation'].value;

    if (password !== confirmPassword) {
      return { 'passwordsMismatch': true };
    }
  }

  static expDateValidator(group: FormGroup) {
    let month = group.controls['exp_month'];
    let year = group.controls['exp_year'];
    if (month.valid && year.valid) {
      return null;
    } else {
      return { 'dateRequired': true }
    }
  }

  static locationValidator(control: Object) {
    if (!control['value'].match(/^(?=.*? )\d+/)) {
        return { 'fullAddressRequired': true };
    }
  }

  static minArrayLength(min: Number) {
    return (control: FormArray) => {
      if(control['value']) {
        if(control['value'].length < min) {
          return { 'minArrayLength': min };
        }
      }
    }
  }

  static maxArrayLength(max: Number) {
    return (control: FormArray) => {
      if(control['value']) {
        if(control['value'].length > max) {
          return { 'maxArrayLength': max };
        }
      }
    }
  }

  static minValue(min: Number) {
    return (control: FormControl) => {
      if(control['value'] < min) {
        return { 'minValue': min };
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/validation.ts